import { modal as modalStore } from 'store';

export const showSuccessSendModal = () => modalStore.open('SuccessModal');

export const showErrorSendModal = () => modalStore.open('ErrorModal');

export const showModal = (name, props) => modalStore.open(name, props);
